/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Ai2OpenScholar8B = ({ color = 'primary', aspectRatio = '1960/170', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Ai2OpenScholar-8B" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Ai2OpenScholar8B, Ai2OpenScholar8B as default };
